export enum EButtonEvents {
    BET_INCREASE_BUTTON_PRESSED = 'BET_INCREASE_BUTTON_PRESSED',
    BET_DECREASE_BUTTON_PRESSED = 'BET_DECREASE_BUTTON_PRESSED',
    BET_INDEX_BUTTON_PRESSED = 'BET_INDEX_BUTTON_PRESSED',
    SPIN_BUTTON_PRESSED = 'SPIN_BUTTON_PRESSED',
    STOP_BUTTON_PRESSED = 'STOP_BUTTON_PRESSED',
    SKIP_BUTTON_PRESSED = 'SKIP_BUTTON_PRESSED',
    CONTINUE_BUTTON_PRESSED = 'CONTINUE_BUTTON_PRESSED',
    TAKE_BUTTON_PRESSED = 'TAKE_BUTTON_PRESSED',
    AUTO_START_BUTTON_PRESSED = 'AUTO_START_BUTTON_PRESSED',
    AUTO_STOP_BUTTON_PRESSED = 'AUTO_STOP_BUTTON_PRESSED',
    GAMBLE_BUTTON_PRESSED = 'GAMBLE_BUTTON_PRESSED',
    TURBO_BUTTON_PRESSED = 'TURBO_BUTTON_PRESSED',
    AUTO_TURBO_BUTTON_PRESSED = 'AUTO_TURBO_BUTTON_PRESSED',
    MUTE_BUTTON_PRESSED = 'MUTE_BUTTON_PRESSED',
    UNMUTE_BUTTON_PRESSED = 'UNMUTE_BUTTON_PRESSED',
    FULLSCREEN_BUTTON_PRESSED = 'FULLSCREEN_BUTTON_PRESSED'
}
